import { IPage } from "../../shared/components/definitions/page/IPage";
import { MonitoreoAnalisisContentRender } from "../../shared/components/modulos/monitoreo/sesion/dashboard/MonitoreoAnalisisContentRender";
import { serviceProvider } from "../../shared/comun/provider/ServiceProvider";
import {
  APP_RUTA_MONITOREO_PLAGAS,
  APP_RUTA_MONITOREO_REPORTE,
} from "../components/ClienteModulesComponent";

/** Página del dashboard histórico de monitoreo de plagas: comportamiento de
 *  cada plaga a lo largo de las sesiones de la finca activa, con selección de
 *  lotes y plagas, franja de tendencias y exportación del reporte imprimible.
 *
 *  Es full-width (sin segundo sidebar): el mockup la define como una vista de
 *  análisis a pantalla completa, no como una lista con detalle. */
export class MonitoreoAnalisisPage implements IPage {
  render(pageContent: HTMLDivElement): void {
    this._content = new MonitoreoAnalisisContentRender(
      () => serviceProvider.getLayoutService().navigate(APP_RUTA_MONITOREO_PLAGAS),
      () =>
        serviceProvider.getLayoutService().navigate(APP_RUTA_MONITOREO_REPORTE),
    );
    pageContent.innerHTML = this._content.render();
    this._content.connect();
  }

  dispose(): void {
    this._content?.dispose();
    this._content = null;
  }

  /** Contenido vivo de la página. */
  private _content: MonitoreoAnalisisContentRender | null = null;
}
